import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators, FormArray} from '@angular/forms';

@Component({
  selector: 'app-edit-form-advanced',
  templateUrl: './edit-form-advanced.html',
  styleUrls: ['./edit-form-advanced.scss']
})

export class EditFormAdvancedComponent implements OnInit {

  @Input() currentForm;
  @Output() configChanged = new EventEmitter<any>();
  public message: FormControl;
  public validators: FormGroup;
  public activeValidators: FormControl;
  public ValidatorList = [];
  public savedValidatorsList = [];
  public editing;
  public index;
  public valList = [
    {name: 'Obrigatório', key: 'required', type: 'boolean', editing: true, value: true, customMessage: '', editable: true},
    {name: 'Máximo de caracteres', key: 'maxLength', type: 'number', editing: true, value: 1, customMessage: '', editable: true},
    {name: 'Mínimo de caracteres', key: 'minLength', type: 'number', editing: true, value: 1, customMessage: '', editable: true},
    {name: 'Máximo de palavras', key: 'maxWords', type: 'number', editing: true, value: 1, customMessage: '',  editable: true},
    {name: 'Mínimo de palavras', key: 'minWords', type: 'number', editing: true, value: 1, customMessage: '',  editable: true},
    // tslint:disable-next-line: max-line-length
    {name: 'Expressão regular', key: 'pattern', type: 'string', editing: true, value: '', customMessage: '', reverse: false,  editable: true},
    {name: 'Validação de CPF', key: 'cpf', type: 'boolean', editing: true, value: true, customMessage: '', editable: true},
    {name: 'Validação personalizada', key: 'custom', type: 'code', editing: true, value: '', customMessage: '',  editable: true},
  ];

  constructor(private formBuilder: FormBuilder) {
    this.validators = this.formBuilder.group({
      formArray: this.formBuilder.array([])
    });
  }

  get formArray() {
      return this.validators.get('formArray') as FormArray;
  }

  public getForm(i): any {
    return this.formArray.controls[i];
  }

  ngOnInit() {
    if (this.currentForm.validatorData) {
      this.executeChanges({
        activeValidators: this.currentForm.validatorData.enable,
        message: this.currentForm.validatorData.message,
        validators:  this.currentForm.validatorData.data
      });
    }
    this.handleType();
    if (this.currentForm.validatorData) {
      this.message = new FormControl(this.currentForm.validatorData.message);
      this.activeValidators = new FormControl(this.currentForm.validatorData.enable);
    } else {
      this.message = new FormControl('');
      this.activeValidators = new FormControl(false);
    }
    if (this.activeValidators.value) {
      this.message.enable({emitEvent: false});
    } else {
      this.message.disable({emitEvent: false});
    }
    this.onchanges();
    if (this.currentForm.validatorData && this.currentForm.validatorData.data && this.currentForm.validatorData.data.length > 0) {
      this.savedValidatorsList = this.currentForm.validatorData.data;
      this.currentForm.validatorData.data.forEach(val => {
        this.addValidator(val);
      });
    }
  }

  handleType() {
    const type = this.currentForm.type;
    if (type === 'number') {
      this.valList = this.valList.filter(val => {
        return val.key === 'custom';
      });
      // tslint:disable: max-line-length
      this.valList.splice(0, 0, {name: 'Obrigatório', key: 'requiredNumber', type: 'boolean', editing: true, value: true, customMessage: '', editable: true});
      this.valList.splice(1, 0, {name: 'Máximo', key: 'max', type: 'number', editing: true, value: 1, customMessage: '', editable: true});
      this.valList.splice(1, 0, {name: 'Mínimo', key: 'min', type: 'number', editing: true, value: 1, customMessage: '', editable: true});
    }
    if (type === 'selectboxes') {
      this.valList = this.valList.filter(val => {
        return val.key === 'custom';
      });
      this.valList.splice(0, 0, {name: 'Obrigatório', key: 'requiredCheck', type: 'boolean', editing: true, value: true, customMessage: '', editable: true});
    }
  }

  onchanges() {
    this.activeValidators.valueChanges.subscribe(val => {
      if (val) {
        this.message.enable({emitEvent: false});
        this.validators.controls.formArray.enable();
      } else {
        this.message.disable({emitEvent: false});
        this.validators.controls.formArray.disable();
        this.stopEditingAll();
      }
      this.executeChanges();
    });
    this.message.valueChanges.subscribe(val => {
      this.executeChanges();
    });
  }

  public addValidator(val) {
    if (val.key === 'required' || val.key === 'requiredNumber' || val.key === 'requiredCheck') {
      this.formArray.insert(0, this.createRuleFormGroup(val));
    } else {
      this.formArray.push(this.createRuleFormGroup(val));
    }
    const validator = {
      key: val.key,
      value: val.value,
      type: val.type,
      name: val.name,
      editing: val.editing,
      customMessage: val.customMessage,
      editable: val.editable,
      reverse: val.reverse
    };
    // this.editing = val.editing;
    if (val.key === 'required' || val.key === 'requiredNumber' || val.key === 'requiredCheck') {
      this.valList.splice(0, 1);
      this.ValidatorList.splice(0, 0, validator);
      this.onValidatorChanges(this.getForm(this.formArray.length - 1));
    } else {
      this.ValidatorList.push(validator);
      this.onValidatorChanges(this.getForm(this.formArray.length - 1));
    }
    // if (val.type === 'boolean') {
    //   this.getForm(this.formArray.length - 1).get('value').setValue(true);
    // }
    this.savedValidatorsList = this.ValidatorList;
    this.executeChanges();
  }

  public editRule(i) {
    this.ValidatorList[i].editing = true;
    // this.editing = true;
    // this.activeValidators.disable({emitEvent: false});
  }

  public saveRule(i) {
    this.ValidatorList[i].value = this.getForm(i).get('value').value;
    if (this.getForm(i).get('message').value.trim() !== '') {
      this.ValidatorList[i].customMessage = this.getForm(i).get('message').value;
    } else {
      this.ValidatorList[i].customMessage = false;
    }
    if (this.getForm(i).get('reverse').value !== null) {
      this.ValidatorList[i].reverse = this.getForm(i).get('reverse').value;
    }
    // this.editing = false;
    this.savedValidatorsList = this.ValidatorList;
    this.executeChanges();
    this.activeValidators.enable({emitEvent: false});
  }

  public stopEditing(i) {
    this.ValidatorList[i].editing = false;
  }

  public stopEditingAll() {
    this.ValidatorList = this.savedValidatorsList;
    this.ValidatorList.forEach(i => {
      i.editing = false;
    });
    this.savedValidatorsList = this.ValidatorList;
  }

  public removeRule(i) {
    if (this.ValidatorList[i].key === 'required') {
      this.valList.splice(0, 0, {name: 'Obrigatório', key: 'required', type: 'boolean', editing: true, value: true, customMessage: '', editable: true});
    }
    if (this.ValidatorList[i].key === 'requiredNumber') {
      this.valList.splice(0, 0, {name: 'Obrigatório', key: 'requiredNumber', type: 'boolean', editing: true, value: true, customMessage: '', editable: true});
    }
    if (this.ValidatorList[i].key === 'requiredCheck') {
      this.valList.splice(0, 0, {name: 'Obrigatório', key: 'requiredCheck', type: 'boolean', editing: true, value: true, customMessage: '', editable: true});
    }

    this.ValidatorList.splice(i, 1);
    this.formArray.removeAt(i);
    this.savedValidatorsList = this.ValidatorList;
    this.executeChanges();
  }

  createRuleFormGroup(val): FormGroup {
    return this.formBuilder.group({
      key: [],
      value: [val.value, Validators.required],
      message: [val.customMessage ? val.customMessage : ''],
      reverse: [val.reverse]
    });
  }

  onValidatorChanges(form): void {
    const value = form.controls.value;
    const message = form.controls.message;
    const reverse = form.controls.reverse;
    reverse.valueChanges.subscribe(val => {
      this.formArray.controls.filter((item, index) => {
        if (item === reverse.parent) {
          this.index = index;
          this.saveRule(index);
        }
      });
    });
    message.valueChanges.subscribe(val => {
      this.formArray.controls.filter((item, index) => {
        if (item === message.parent) {
          this.index = index;
          this.saveRule(index);
        }
      });
    });
    value.valueChanges.subscribe(val => {
      this.formArray.controls.filter((item, index) => {
        if (item === value.parent) {
          this.index = index;
          this.saveRule(index);
        }
      });
    });
  }

  emitChanges() {
    this.configChanged.emit(this.currentForm);
  }

  executeChanges(preset?) {
    let obj: any;
    if (preset) {
      obj = preset;
    } else {
      obj =  {
        activeValidators: this.activeValidators.value,
        message: this.message.value,
        validators:  this.savedValidatorsList
      };
    }
    this.setValidationsData(obj);
    this.emitChanges();
  }

  setValidationsData(obj) {
    if (obj.validators.length > 0) {
      this.currentForm.validatorData = {
        enable: obj.activeValidators,
        message: obj.message,
        data: obj.validators
      };
    } else {
      this.currentForm.validatorData = {
        enable: obj.activeValidators,
        message: obj.message,
        data: []
      };
    }
  }

}
